import styled from "@emotion/styled";
import { Text } from "components/general/Text";
import {
  LARGE_DESKTOP_WIDTH,
  MID_DESKTOP_WIDTH,
  MOBILE_WIDTH,
  TABLET_WIDTH,
  useIsMobile,
  useIsTablet,
} from "hooks/useDeviceType";
import rocket from "img/home/Rocket.svg";
import robot from "img/home/Robot.svg";
import { ReactComponent as StreamerImage7 } from "img/home/streamer-7.svg";
import { ReactComponent as StreamerImage8 } from "img/home/streamer-8.svg";
import { css } from "@emotion/react";

export const FeatureLanding = () => {
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();
  const textProps = {
    textStyle: "Title" as const,
    size: "XXL" as const,
    shouldScale: true,
    textCss: css`
      @media (max-width: ${MOBILE_WIDTH}px) {
        font-size: 16px;
      }
    `,
  };

  let streamerImageTop8 = 0;
  if (isMobile) {
    streamerImageTop8 = -100;
  } else if (isTablet) {
    streamerImageTop8 = -60;
  }

  return (
    <Container>
      <div
        style={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "60dvh",
          top: "16dvh",
        }}
      >
        <div style={{ marginBottom: 28, position: "relative" }}>
          <Rocket src={rocket} alt={"Rocket icon"} />
          <Robot src={robot} alt={"Robot icon"} />
          <Title1>Buy or sell,</Title1>
          <Title2>we'll execute it</Title2>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            maxWidth: isMobile ? 220 : 800,
          }}
        >
          <Text {...textProps}>Seamless and efficient crypto trading for everyone</Text>
        </div>
      </div>

      <div style={{ position: "absolute", top: isMobile ? 158 : "40dvh", left: 0, zIndex: 0 }}>
        <StreamerImage7 {...(isTablet || isMobile ? { width: isMobile ? 100 : 140 } : {})} />
      </div>
      <div
        style={{
          position: "absolute",
          top: streamerImageTop8,
          right: 0,
          zIndex: 0,
        }}
      >
        <StreamerImage8 {...(isTablet || isMobile ? { width: isMobile ? 130 : 200 } : {})} />
      </div>
    </Container>
  );
};

// Sub-components

const Container = styled.section(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 36,
  padding: "0px min(10%, 186px)",
  justifyContent: "center",
  textAlign: "center",
  marginTop: 100,

  [`@media (max-width: ${MOBILE_WIDTH}px)`]: {
    padding: "0 24px",
    gap: 24,
  },
}));

const Rocket = styled.img`
  position: absolute;
  left: 6%;
  top: -170px;
  z-index: -1;
  transform: rotate(45deg);

  @media (max-width: ${LARGE_DESKTOP_WIDTH}px) {
    left: 6%;
    top: -175px;
  }

  @media (max-width: ${MID_DESKTOP_WIDTH}px) {
    left: 4%;
    top: -185px;
  }
  @media (max-width: ${TABLET_WIDTH}px) {
    top: -170px;
    left: 0;
  }
`;

const Robot = styled.img`
  position: absolute;
  right: -5cqw;
  top: -20px;
  z-index: -1;
  @media (max-width: ${LARGE_DESKTOP_WIDTH}px) {
    right: -6cqw;
    top: -30px;
  }

  @media (max-width: ${MID_DESKTOP_WIDTH}px) {
    right: -8cqw;
    top: -50px;
  }
  @media (max-width: ${TABLET_WIDTH}px) {
    top: -40px;
    right: -13cqw;
  }

  @media (max-width: ${MOBILE_WIDTH}px) {
    top: 105px;
    right: -15%;
  }
`;

const Title1 = styled.h1(() => ({
  fontFamily: "Quincy CF",
  fontSize: "max(6cqw, 6cqh)",
  fontWeight: 800,
  lineHeight: "100%",
  [`@media (max-width: ${TABLET_WIDTH}px)`]: {
    fontSize: 70,
  },
  [`@media (max-width: ${MOBILE_WIDTH}px)`]: {
    fontSize: 50,
  },
}));

const Title2 = styled(Title1)(({ theme }) => ({
  color: theme["Colour ramps"].Green[500],
}));
